import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import download from '../../assets/Images/icons8-download-24.png';
import loader from '../../assets/Images/loader.gif';
// import { click } from '@testing-library/user-event/dist/click';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';
import { useParams } from "react-router-dom";
import imageCompression from 'browser-image-compression';

const FaultRepairViewSr = () => {
    const fileInputRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const srNo = searchParams.get("srNumber");
    // console.log('srNo', srNo);
    const EmailID = sessionStorage.getItem('userEmail')
    const [loading, setLoading] = useState(true);
    const [activeForm, setActiveForm] = useState('form1');
    const [srDetails, setSrDetails] = useState([]);
    const [networkTech, setnetworkTech] = useState();
    const [customerID, setCustomerID] = useState()
    const [srRcCode, setSrRcCode] = useState([]);
    const [srRcOpts, setSrRcOpts] = useState([]);
    const [srRcCode1, setSrRcCode1] = useState([]);
    const [srRcOpts1, setSrRcOpts1] = useState([]);
    const [srRcOpts2, setSrRcOpts2] = useState([]);
    const [srRcCode2, setSrRcCode2] = useState([]);
    const [viewSRNotes, setViewSRNotes] = useState([]);
    const [fileName, setFileName] = useState([]);
    const [documentfile, setDocumentfile] = useState('');
    const [attachedFile, setAttachedFile] = useState([]); // Store uploaded files
    const [base64Strings, setBase64Strings] = useState([]); // Store base64 
    const [title, setTitle] = useState();
    const [desciption, setDescription] = useState();
    const [docdesciption, setDocDescription] = useState();
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);


    useEffect(() => {
        // Get the current position when the component mounts
        const getPosition = () => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        setLatitude(position.coords.latitude);
                        setLongitude(position.coords.longitude);
                    },
                    (error) => {
                        console.error('Error getting location:', error);
                    }
                );
            } else {
                console.error('Geolocation is not supported by this browser.');
            }
        };

        getPosition(); // Call the function to get the current position
    }, []); // Run only once when the component mounts

    // console.log('latitude',latitude);
    // console.log("longitude",longitude);

    const handleIconClick = (formId) => {

        if (activeForm !== formId) {
            setActiveForm(formId);
        }
    };

    function getAbbreviatedName(fileName) {
        const maxLength = 15; // Maximum length of the abbreviated name
        if (fileName.length <= maxLength) {
            return fileName; // Return the original name if it's already short
        } else {
            // Abbreviate the name and add ellipsis at the end
            return fileName.slice(0, maxLength - 3) + '...';
        }
    }


    const handleIconuPLOClick = () => {
        // alert('232')
        fileInputRef.current.click();
    };
    const isValidBase64 = (base64String) => {
        // Regular expression to check if the string is valid base64
        const base64Regex = /^[a-zA-Z0-9+/]*={0,2}$/;
        return base64Regex.test(base64String);
    };


    const handleFileUpload = async (event) => {
        const selectedFile = event.target.files[0];
        // Set compression options
        const options = {
            maxSizeMB: 1, // Maximum file size in MB
            maxWidthOrHeight: 1920, // Max width or height
            useWebWorker: true, // Use web worker for faster compression
        };
        // Compress the image file
        const compressedFile = await imageCompression(selectedFile, options);
        // Update state with selected file
        // console.log("selectedFile.name", selectedFile.name);
        setAttachedFile(selectedFile.name);

        // Read the file as a data URL and handle the base64 string
        const reader = new FileReader();
        reader.onloadend = async () => {
            // Handle base64 string
            let base64String = reader.result;

            // Check if the base64 string exists
            if (base64String) {
                // Remove the prefix "data:image/png;base64," if it exists
                const prefixIndex = base64String.indexOf(";base64,");
                if (prefixIndex !== -1) {
                    base64String = base64String.slice(prefixIndex + 8); // +8 to remove the prefix including ";base64,"
                }

                // Remove quotes from the beginning and end of the string, if present
                base64String = base64String.replace(/^"|"$/g, "");
                // console.log("base64", base64String);
                // Update base64Strings state with the single base64 string
                // setBase64Strings(base64String);
                setBase64Strings((prevBaseString) => [...prevBaseString, base64String])

                // Call handleDocumentSave API after handling file upload
                // await handleSubmit(base64String, selectedFile.name);
            } else {
                // console.log("Base64 string is empty or undefined");
            }
        };

        reader.readAsDataURL(compressedFile);
        // console.log("fileuploaded", [selectedFile.name]);
        // Update state with file name
        // setFileName(selectedFile.name)
        setFileName((prevFileNames) => [...prevFileNames, selectedFile.name]);
    };



    const style = {
        control: (base) => ({
            ...base,
            border: 0,
            // Remove box shadow
            boxShadow: "none",
            backgroundColor: "transparent",
            color: "black",
        }),
    };
    const redirectFaultRepairDotSRPage = () => {
        navigate('/faultRepairDotSr')
    }

    const handleTitle = (e) => {
        const value = e.target.value
        setTitle(value)
    }
    const handleDescription = (e) => {
        const value = e.target.value
        setDescription(value)
    }
    const handleDocDescription = (e) => {
        const value = e.target.value
        setDocDescription(value)
    }


    const handleAddSRNotes = async () => {
        if (!title && !desciption) {
            toast.warning("Please Enter Title and Description", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else if (!title) {
            toast.warning("Please Enter Title", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else if (!desciption) {
            toast.warning("Please Enter Description", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else {
            try {
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestData = {
                    Action: 'createSRNotesDoT',
                    Authkey: 'ac7b51de9d888e1458dd53d8aJAN3ba6f',
                    NoteDes: desciption,
                    NoteTitle: title,
                    SrNumber: srNo,
                    password: sessionStorage.getItem('password'),
                    username: sessionStorage.getItem('userName')
                };
                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(requestData),
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();
                // console.log('API ADDED SR Notes :', result);

                if (result.Response.message == 'Invalid SR') {
                    toast.warning(`Invalid SR`, {
                        position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500
                    });
                }
                else {
                    toast.success(`${result.Response.message}`, {
                        position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500
                    });
                    FetchViewSrNotes();

                }


            } catch (error) {
                console.error(error)
            }
        }
    }

    const handleRcodeChange = async (selection) => {
        // console.log("selection", selection);
        if (!selection) {
            toast.warning("select the Resolution Code ", {
                position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500, className: ""
            });
        }

        setSrRcCode(selection)
        try {
            // console.log("Selected City:", selection.label);

            const apiUrl = process.env.REACT_APP_API_URL;
            const requestData = {
                Action: 'getRCtwoDOT',
                Authkey: 'ac7b51de9d888e1458dd53d8aJAN3ba6f',
                RConeId: selection.value, // Use the value from selectedOption

            };

            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestData),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            // console.log('API Response RC One:', result);
            setSrRcOpts1(result.data[0])

        } catch (error) {
            console.error(error)
        }
    };


    const handleRcode1Change = async (selection) => {
        // console.log("selection", selection);

        setSrRcCode1(selection)
        try {
            // console.log("Selected City:", selection.value);

            const apiUrl = process.env.REACT_APP_API_URL;
            const requestData = {
                Action: 'getRCthreeDOT',
                Authkey: 'ac7b51de9d888e1458dd53d8aJAN3ba6f',
                RCtwoId: selection.value, // Use the value from selectedOption

            };

            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestData),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            // console.log('API Response RC Two:', result);
            setSrRcOpts2(result.data[0])

        } catch (error) {
            console.error(error)
        }
    };


    const handleRcode2Change = (selection) => {
        // console.log("selection", selection);
        setSrRcCode2(selection)
    };

    // const handleSubmit = async () => {
    //     const document = base64Strings.map((base64String, index) => ({
    //         fileNameWithExtension: fileName[index],
    //         fileContent: base64String
    //     }));
    //     const apiUrl1 = process.env.REACT_APP_API_URL;
    //     const requestData1 = {
    //         Action: "uploadDOTdocument",
    //         Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
    //         username: sessionStorage.getItem('userName'),
    //         password: sessionStorage.getItem('password'),
    //         SRno: srNo,
    //         title: 'DOT',
    //         description: docdesciption ? docdesciption : "dot",
    //         documentRequire: {
    //             documentData: document
    //         },
    //     };
    //     const response1 = await fetch(apiUrl1, {
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/json',
    //         },
    //         body: JSON.stringify(requestData1),
    //     });
    //     const result1 = await response1.json();
    //     // console.log('RC Details Succesfully updated', result1.data);
    //     toast.success(result1.Response.Message, {
    //         position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500
    //     });
    // }


    const handleSubmit = async () => {

        try {
            if (!srRcCode) {
                toast.warning("Please Select Resolution Code One", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            } else if (!srRcCode1) {
                toast.warning("Please Select Resolution Code Two", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            } else if (!srRcCode2) {
                toast.warning("Please Select Resolution Code Three", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });

            } else if (!docdesciption) {
                toast.warning("Please Enter Description", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }

            setLoading(true);
            const srRcCodeValue = srRcCode.value
            const srRcCodeValue1 = srRcCode1.value
            const srRcCodeValue2 = srRcCode2.value
            const LongitudeValue = `${longitude}`
            const latitideValue = `${latitude}`
            // const newbase64String = base64Strings
            // const fileNameWithExtension = fileName 
            const document = base64Strings.map((base64String, index) => ({
                        fileNameWithExtension: fileName[index],
                        fileContent: base64String
                    }));
            const apiUrl = process.env.REACT_APP_API_URL
            const requestData = {
                Action: "saveRCdetails",
                ActionCode: "",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                ContactNo: '',
                Contacted: '',
                CustomerID: customerID,
                CustomerName: '',
                ETR: '',
                ETRReason: '',
                EmailId: EmailID,
                EmpId: '',
                EngId: '',
                HoldReason: '',
                Latitude: latitideValue,
                Longitude: LongitudeValue,
                NetworkType: networkTech,
                RConeId: srRcCodeValue,
                RCthirdId: srRcCodeValue2,
                RCtwoId: srRcCodeValue1,
                ReasonOf: "DoT",
                SlotType: '',
                Source: "FFA App",
                TaskType: '',
                UpdatedBy: sessionStorage.getItem('userName'),
                SrNumber: srNo

            };
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestData),
            });
            if (response.ok) {
                const result = await response.json();
                // console.log('RC Details Succesfully updated', result);
                toast.warning(result, {
                    position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500
                  });
            
                const apiUrl1 = process.env.REACT_APP_API_URL;
                    const requestData1 = {
                        Action: "uploadDOTdocument",
                        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                        username: sessionStorage.getItem('userName'),
                        password: sessionStorage.getItem('password'),
                        SRno: srNo,
                        title: 'DOT',
                        description: docdesciption ? docdesciption : "",
                        documentRequire: {
                            documentData: document
                        },
                    };
                    const response1 = await fetch(apiUrl1, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(requestData1),
                    });
                    const result1 = await response1.json();
                    // console.log('RC Details Succesfully updated', result1.data);
                    toast.success(result1.Response.Message, {
                        position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500
                    });


                if (result.Status == '1') {
                    const apiUrl2 = process.env.REACT_APP_API_URL;
                    const requestData2 = {
                        Action: "saveBinmovementSR",
                        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                        BinId: '220',
                        SrNumber: srNo,
                        password: sessionStorage.getItem('password'),
                        username: sessionStorage.getItem('userName')

                    };
                    const response2 = await fetch(apiUrl2, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(requestData2),
                    });

                    const result2 = await response2.json();
                    // console.log('Save Bin Details Succesfully updated', result2);
                    toast.success(result2.Response.Message, {
                        position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500
                      });
                }
            } else {
                console.error('Error fetching data:', response.status);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }



    // Fault repair DOT View SR Details Api

    useEffect(() => {
        const FetchDotSRsDetails = async () => {
            try {
                setLoading(true);
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestData = {
                    Action: "getDOTbySrNumber",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    srNumber: srNo

                };
                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(requestData),
                });
                if (response.ok) {
                    const result = await response.json();
                    // console.log('DOT View SR Details Api', result.data);
                    setSrDetails(result.data);
                    // console.log('Network tech', result.data[0].customerNetworkTech);
                    setnetworkTech(result.data[0].customerNetworkTech)
                    // console.log('Customer ID', result.data[0].customerID);
                    setCustomerID(result.data[0].customerID)
                    setLoading(false);
                    if (result && result.response && result.response.Status !== "Failure") {



                    } else {
                        const errorMessage = (result.response.Status);
                        toast.warning(`${errorMessage}`, {
                            position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500
                        });
                    }
                } else {
                    console.error('Error fetching data:', response.status);
                }

            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        }
        if (srNo) {
            FetchDotSRsDetails()
        }

    }, []);

    // END 


    // Fault repair RCone dropdown  Api
    useEffect(() => {
        const FetchRConeDrops = async () => {
            try {
                setLoading(true);
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestData = {
                    Action: "getRConeDOT",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",


                };
                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(requestData),
                });
                if (response.ok) {
                    const result = await response.json();
                    // console.log('DOT RCone Details Api', result.data);
                    setSrRcOpts(result.data)
                    setSrRcCode(result.data);
                    setLoading(false);

                } else {
                    console.error('Error fetching data:', response.status);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        }
        FetchRConeDrops()
    }, []);
    // END   

    // Fault repair View SR Notes details Api

    const FetchViewSrNotes = async () => {
        try {
            setLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestData = {
                Action: "getNotesBySrNumber",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                SrNumber: srNo


            };
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestData),
            });
            if (response.ok) {
                const result = await response.json();
                // console.log('View SR Notes', result);
                if (result.Notes.length === 0) {
                    // alert('101w');
                    toast.warning(`No Notes Found for this SrNumber`, {
                        position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500
                    });
                } else {
                    setViewSRNotes(result.Notes); // Assuming `result.Notes` contains the array of notes
                }
                setLoading(false);

            } else {
                console.error('Error fetching data:', response.status);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        FetchViewSrNotes(srNo);
    }, [srNo]);
    // END   

    return (
        <>

            {/* {Header} */}
            <div className="container-fluid text-light Header-style header" >
                <div className="p-3">
                    <span className='' style={{ cursor: 'pointer' }} onClick={redirectFaultRepairDotSRPage}>
                        <i className="fa-solid fa-arrow-left-long"></i>
                    </span>
                    <span className='p-1 m-3'>DOT Periodic Verification</span>
                </div>
            </div>
            {loading ? (
                <div className="loader-wrapper">
                    <div className="loader">
                        <img src={loader} alt="loading...."></img>
                    </div>
                </div>
            ) : (
                <div className="container-fluid form-container">
                    {/* **************Sr Details toggle******************* */}
                    <div className="contact-toggle" onClick={() => handleIconClick('form1')}>
                        <span className="toggle-text">Sr Details</span>
                        <span className=" float-end">
                            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                        </span>
                    </div>
                    {/* {loading && (
                                                <div className="loader-wrapper">
                                                    <div className="loader">
                                                        <img src={loader} alt="loading...."></img>
                                                    </div>
                                                </div>
                                            )} */}
                    {activeForm === 'form1' &&
                        <div className="container cstm-container shadow mb-3 bg-body rounded mt-4" id="form1">


                            {/* *********Sr Details form******** */}

                            <form className="contact-form p-2" >
                                <div className="col" >
                                    {/* <div className="card shadow"> */}
                                    {/* {EngineerSRs.map((sr,index) => ( */}

                                    {/* <div className="card mb-12 " > */}
                                    {srDetails.map((sr, index) => (
                                        <div className="m-2 card-data" >

                                            <div className="lead-card">
                                                <div className="card-data-row">
                                                    <div className="col-5"  >SR Number </div>
                                                    <div className="col-1">:</div>
                                                    <div className="col-6">{sr.srNumber}</div>
                                                </div>
                                                <div className="card-data-row">
                                                    <div className="col-5" >Customer Id </div>
                                                    <div className="col-1">:</div>
                                                    <div className="col-6" style={{ color: 'red' }}>{sr.customerID}</div>
                                                </div>
                                                <div className="card-data-row">
                                                    <div className="col-5" >SLA Status </div>
                                                    <div className="col-1">:</div>
                                                    <div className="col-6">{sr.slaStatus}</div>
                                                </div>
                                                <div className="card-data-row">
                                                    <div className="col-5" >Mobile Number </div>
                                                    <div className="col-1">:</div>
                                                    <div className="col-6">{sr.customerMobile}</div>
                                                </div>
                                                <div className="card-data-row">
                                                    <div className="col-5" >Customer Name </div>
                                                    <div className="col-1">:</div>
                                                    <div className="col-6">{sr.customerName}</div>
                                                </div>
                                                <div className="card-data-row">
                                                    <div className="col-5" >Address </div>
                                                    <div className="col-1">:</div>
                                                    <div className="col-6">{sr.customerAddress}</div>
                                                </div>
                                                <div className="card-data-row">
                                                    <div className="col-5" >Sub SR Type </div>
                                                    <div className="col-1">:</div>
                                                    <div className="col-6">{sr.srSubType}</div>
                                                </div>
                                                <div className="card-data-row">
                                                    <div className="col-5" >Customer Segment </div>
                                                    <div className="col-1">:</div>
                                                    <div className="col-6">{sr.segment}</div>
                                                </div>
                                                <div className="card-data-row">
                                                    <div className="col-5" >SR Type </div>
                                                    <div className="col-1">:</div>
                                                    <div className="col-6">{sr.srType}</div>
                                                </div>
                                                <div className="card-data-row">
                                                    <div className="col-5" >SLA Clock</div>
                                                    <div className="col-1">:</div>
                                                    <div className="col-6">{sr.slaClock}</div>
                                                </div>
                                            </div>


                                        </div>
                                    ))}

                                </div>
                            </form>
                        </div>}

                    {/* **************View Sr Details toggle******************* */}
                    <div className="contact-toggle mt-2" onClick={() => handleIconClick('form2')}>
                        <span className="toggle-text">View Sr Details</span>
                        <span className=" float-end">
                            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                        </span>
                    </div>
                    {activeForm === 'form2' &&
                        <div className=" container shadow mb-3 bg-body rounded mt-4" id="form2">


                            {/* *********View Sr Details form******** */}
                            <form className="contact-form p-2" >

                                {viewSRNotes && viewSRNotes.length !== 0 ? (
                                    viewSRNotes.map((sr, index) => (
                                        <div key={index} style={{ border: '1px solid #ccc', padding: '10px', marginBottom: '10px' }}>
                                            <div style={{ marginBottom: '5px' }}>
                                                <span style={{ fontWeight: 'bold' }}>Created by: </span>
                                                <span >{sr.createdby}</span> <span style={{ fontSize: 'small' }}>({sr.createdon})</span>
                                            </div>
                                            <div style={{ marginBottom: '5px' }}>
                                                <span style={{ fontWeight: 'bold' }}>Title:</span>
                                                <span>{sr.title}</span>
                                            </div>
                                            <div>
                                                <span style={{ fontWeight: 'bold' }}>Description: </span>
                                                <span>{sr.description}</span>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div>No data available</div>
                                )}



                            </form>

                        </div>}


                    {/* **************Add Sr Details toggle******************* */}
                    <div className="contact-toggle mt-2" onClick={() => handleIconClick('form3')}>
                        <span className="toggle-text">Add Sr Details</span>
                        <span className=" float-end">
                            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                        </span>
                    </div>
                    {activeForm === 'form3' &&
                        <div className=" container shadow mb-3 bg-body rounded mt-4" id="form3">


                            {/* *********Add Sr Details form******** */}
                            <form className="contact-form p-2" >
                                <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        placeholder=""
                                        className=" form-control input-text form-control-sm"
                                        id="lastName"
                                        name="lastName"
                                        value={title}
                                        onChange={handleTitle}
                                        // disabled={disableFileds}
                                        style={{ background: 'transparent' }}

                                    />
                                    <label htmlFor="floatingInput">Title*</label>
                                </div>
                                <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        placeholder=""
                                        className=" form-control input-text form-control-sm"
                                        id="firstName"
                                        name="firstName"
                                        value={desciption}
                                        onChange={handleDescription}
                                        // disabled={disableFileds}
                                        style={{ background: 'transparent' }}
                                    />
                                    <label htmlFor="floatingInput">Description*</label>
                                </div>
                                <br></br>
                                <div className=' text-center mt-3 mb-3'>
                                    <button
                                        type="button"
                                        className="btn etr-btn text-light bg-dark mx-auto rounded-pill"
                                        onClick={handleAddSRNotes}

                                    >
                                        Add Sr Notes
                                    </button>
                                </div>
                            </form>

                        </div>}

                    {/* **************RC/Document  Details toggle******************* */}
                    <div className="contact-toggle mt-2 mb-3" onClick={() => handleIconClick('form4')}>
                        <span className="toggle-text">RC/Document Details</span>
                        <span className=" float-end">
                            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                        </span>
                    </div>

                    {activeForm === 'form4' &&
                        <div className=" container shadow mb-3 bg-body rounded mt-4" id="form4">

                            {/* *********Installation Addresss form******** */}
                            <form className=" contact-form p-2" >
                                <div className="">
                                    <label className="select-search-label mt-1">Resolution Code*</label>
                                    <Select
                                        className=" basic-single form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        id="sssss"
                                        name="fffff"
                                        value={srRcCode}
                                        placeholder="Select option"
                                        onChange={handleRcodeChange}
                                        options={srRcOpts.map((option) => ({
                                            value: option.rc_oneId,
                                            label: option.rootCauseOne
                                        }))}
                                        styles={style}
                                        isSearchable={true}

                                    />




                                </div>

                                <div className="">
                                    <label className="select-search-label mt-1">Resolution Code Two*</label>
                                    <Select
                                        className=" basic-single form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        id="ssss"
                                        name="ffff"
                                        // isDisabled={disableFileds}
                                        value={srRcCode1}

                                        onChange={handleRcode1Change}
                                        options={[
                                            { value: srRcOpts1.rc_twoId, label: srRcOpts1.rootCauseTwo }
                                        ]}

                                        // styles={compcustomStyles}
                                        styles={style}
                                        placeholder="Select option"
                                        isSearchable={true}
                                    />

                                </div>

                                <div className="">

                                    <label className="select-search-label mt-1"> Resolution Code Three*</label>
                                    <Select
                                        className="basic-single form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        placeholder="Select option"
                                        value={srRcCode2}
                                        options={[
                                            { value: srRcOpts2.rc_thirdId, label: srRcOpts2.rootCauseThree }
                                        ]}
                                        onChange={handleRcode2Change}
                                        styles={style}
                                    // isDisabled={disableFileds}
                                    />

                                </div>
                                <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        placeholder=""
                                        className=" form-control input-text form-control-sm"
                                        id="firstName"
                                        name="firstName"
                                        value={docdesciption}
                                        onChange={handleDocDescription}

                                        style={{ background: 'transparent' }}
                                    />
                                    <label htmlFor="floatingInput">Description*</label>
                                </div>


                                <div>
                                    <div className="cstm-docart" style={{ cursor: 'pointer', marginBottom: '10px' }} onClick={handleIconuPLOClick}>
                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder="Click here"
                                                className="form-control input-text form-control-sm"
                                                id="firstName"
                                                name="firstName"

                                            />
                                            <i className="fas fa-paperclip cstm-hand text-secondary"
                                                style={{ position: 'absolute', top: '70%', right: '20px', transform: 'translateY(-50%)', cursor: 'pointer' }}></i>
                                            <label htmlFor="floatingInput">Attach File(s)</label>
                                        </div>
                                        <input
                                            type="file"
                                            className="d-none"
                                            accept="image/jpeg, image/png, message/rfc822"
                                            onChange={handleFileUpload}
                                            ref={fileInputRef}
                                            // disabled={disableFileds}
                                            multiple // Allow multiple file selection
                                        />
                                    </div>
                                    {/* {console.log("fileInputRef",fileInputRef)} */}
                                    <div className="input-box p-3">
                                        <label htmlFor="floatingInput">File(s)</label>
                                        {/* {fileName.map((fileName, index) => (
                                        <input
                                            type="text"
                                            placeholder=""
                                            className=" form-control input-text form-control-sm"
                                            id="firstName"
                                            name="firstName"
                                            value={getAbbreviatedName(fileName)}


                                            style={{ background: 'transparent', position: "" }}
                                        />
                                    ))} */}
                                        <table className='table'>
                                            {/* {fileName.map((fileName, index) => (
                                        <tr key={index}>
                                            <td>{getAbbreviatedName(fileName)}</td>
                                        </tr>))} */}
                                            {fileName.length > 0 ? (
                                                fileName.map((file, index) => (
                                                    <tr key={index}>
                                                        <td>{getAbbreviatedName(file)}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td></td>
                                                </tr>
                                            )}

                                            <hr />
                                        </table>

                                    </div>


                                </div>

                                <div className=" text-center mt-4 mb-3">
                                    <button type="button" className="btn etr-btn text-light bg-dark mx-auto rounded-pill" onClick={handleSubmit} >Submit</button>
                                </div>

                            </form>
                        </div>}
                </div>)}
        </>
    )
}
export default FaultRepairViewSr